// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageCropRotate_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.80951 7.7856C3.40848 5.92251 4.63514 4.27129 6.39222 3.21134 10.2186.9031 15.1113 2.27291 17.3204 6.27089L15.5884 7.31575 20.1864 9.36796 20.7845 4.18118 19.0525 5.22604C16.291.228556 10.1751-1.48371 5.39222 1.40159 2.5589 3.11079.82892 6.04993.463379 9.2009L2.80951 7.7856ZM9 18.6426C6.75443 18.2267 4.69363 16.8156 3.4641 14.5905L5.19615 13.5457.598077 11.4934 0 16.6802 1.73206 15.6354C3.33229 18.5314 6.059 20.3242 9 20.7584V18.6426Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 12.5828V21.9865H20V24H22V21.9865H24V19.8968H22V10.493H13V8.40332H11V10.493H9V12.5828H11ZM20 19.8968V12.5828H13V19.8968H20Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageCropRotate is a generated icon component.
 */
let IconImageCropRotate = IconImageCropRotate_1 = class IconImageCropRotate extends IconBaseElement {
    render() {
        return html `${IconImageCropRotate_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageCropRotate.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconImageCropRotate = IconImageCropRotate_1 = __decorate([
    customElement('zui-icon-image-crop-rotate')
], IconImageCropRotate);
export { IconImageCropRotate };
